var _rect, _title, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouseRightClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    width: 405,
    height: 405,
    xmlSpace: "preserve",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dc9b3b",
    fillOpacity: 1,
    stroke: "none",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    d: "M0.6560821415290904,202.8068835735321 C0.6560821415290904,91.4575270697557 90.97928244474642,1.2645483016967773 202.4894062758789,1.2645483016967773 C313.99953010701137,1.2645483016967773 404.32273041022876,91.4575270697557 404.32273041022876,202.8068835735321 C404.32273041022876,314.1562400773085 313.99953010701137,404.34921884536743 202.4894062758789,404.34921884536743 C90.97928244474642,404.34921884536743 0.6560821415290904,314.1562400773085 0.6560821415290904,202.8068835735321 z",
    id: "svg_17",
    className: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "",
    stroke: "#dadada",
    strokeOpacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.91125315778277,35.44973632990002 C151.9190099263621,35.44973632990002 96.25203743965547,64.25353676726891 96.25203743965547,119.31149411107235 V259.5579297410421 c0,61.9557716336369 48.309167537978695,112.3569966217183 107.69529109403621,112.3569966217183 c59.385219093248814,0 107.6943866312275,-50.40122498808139 107.6943866312275,-112.3569966217183 V119.31149411107235 C311.64171516491916,61.69068264809138 257.3558573870887,35.44973632990002 206.91125315778277,35.44973632990002 zM291.3717991592717,259.5579297410421 c0,50.297427509027806 -39.21931631060122,91.20684484438213 -87.42447062558008,91.20684484438213 c-48.206963240596245,0 -87.42266169996269,-40.90941733535433 -87.42266169996269,-91.20684484438213 v-65.59340146774197 c18.10191865320725,5.713579415176695 52.17393711952934,14.357078580002216 92.45509276753764,14.357078580002216 c25.790756989917295,0 54.11491430698726,-3.5942236155917477 82.39203955800511,-13.745617067032025 V259.5579297410421 zM291.3717991592717,172.07930162157538 c-73.8792356025746,29.471878757095578 -152.26902723210753,7.280921348885777 -174.84713232554276,-0.3434752943227613 V119.31149411107235 c0,-40.73390523440918 46.5698855568596,-62.71254961728211 90.38658632405382,-62.71254961728211 c42.04033581091867,0 84.46054600148894,19.3884254737631 84.46054600148894,62.71254961728211 V172.07930162157538 zM215.3498911629004,81.11024736557057 v76.66670525586724 c0,5.838136390040993 -4.543116688071351,10.576019502114022 -10.135410234228063,10.576019502114022 c-5.5941024717741,0 -10.136314697036758,-4.737883112073029 -10.136314697036758,-10.576019502114022 V81.11024736557057 c0,-5.837192776595051 4.541307762453962,-10.575075888668081 10.136314697036758,-10.575075888668081 C210.80587001202034,70.53517147690248 215.3498911629004,75.27305458897551 215.3498911629004,81.11024736557057 zM281.7184676020777,158.47617018488054 c0,0 -42.22665514950968,12.334914965349258 -56.588620088766106,9.691853703266695 V70.3521104683898 C225.1298475133116,70.3521104683898 292.6986460996262,71.23438904034523 281.7184676020777,158.47617018488054 z",
    id: "svg_2",
    stroke: "#dadada",
    strokeOpacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseRightClick);
export default __webpack_public_path__ + "static/media/mouse-right-click.e35f49a719ef60da3b0f1139f1cfa4e8.svg";
export { ForwardRef as ReactComponent };